import type {
	CurrencyEnum,
	GoalCategoryTypeEnum,
	GoalCoveredStateEnum,
	GoalPortfolioResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";

export enum FutureContractTypeEnum {
	Savings = "savings",
	Mortgage = "mortgage",
	Loan = "loan",
	Insurance = "insurance",
	Pension = "pension",
}

export type GoalDetail = {
	id: string;
	name: string;
	category: GoalCategoryTypeEnum;
	status: GoalCoveredStateEnum | null;
	completed: boolean;
	totalValue: number;
	savingsTarget: number;
	ownFunds: number;
	loanAmount: number;
	coveredAmount: number;
	dueYear: number;
	dueIn: string;
	currencyCode?: CurrencyEnum;
	portfolios?: GoalPortfolioResponseDTO[];
	rentMode: boolean;
	monthlyRent: number;
	rentYears: number;
	monthlyContribution: number;
	agent?: { id: number; name: string };
};
